(() => {
    const shieldModal = document.querySelector(`dialog#shield-modal`);
    const clipboardAlert = document.querySelector(`#shield-clipboard-alert`);

    const showCopyAlert = (message) => {
        clipboardAlert.textContent = message;
        clipboardAlert.classList.add("visible");

        setTimeout(() => {
            clipboardAlert.textContent = "";
            clipboardAlert.classList.remove("visible");
        }, 2500);
    };

    const copyCodeToClipboard = async (code) => {
        try {
            await window.navigator.clipboard.writeText(code);
            showCopyAlert("Copied to clipboard!");
        } catch (error) {
            console.error("Error writing to clipboard");
            showCopyAlert("Copy failed, please copy manually.");
        }
    };

    const showShieldModal = () => {
        shieldModal.showModal();
        observer.disconnect();
    };

    const hideShieldModal = () => {
        shieldModal.close();
    };

    const handleModalClick = (event) => {
        if (event.target.id !== "shield-modal") return;
        hideShieldModal();
    };

    const handleCopyCodeButtonClick = () => {
        const discountCode = document.querySelector(`#shield-discount-code-text`).textContent;
        if (discountCode) {
            copyCodeToClipboard(discountCode);
        } else {
            showCopyAlert("Copy failed, please copy manually.");
        }
    };

    // Item has been added to cart.
    const observer = new MutationObserver(() => {
        // showShieldModal();
    });

    observer.observe(document.querySelector(`#cart-icon-bubble`), { attributes: false, childList: true, subtree: true });

    shieldModal.addEventListener("click", handleModalClick);
    document.querySelector(`#shield-close-dialog-button`).addEventListener("click", hideShieldModal);
    document.querySelector(`#shield-copy-code-button`).addEventListener("click", handleCopyCodeButtonClick);
    document.querySelector(`#shield-no-thanks`).addEventListener("click", hideShieldModal);
})();